import React from 'react';

import CharmaLogo from 'Shared/components/Logos/CharmaLogo';

import './PageWrapper.scss';

type Props = {
  children: React.ReactNode;
};

function PageWrapper({ children }: Props) {
  return (
    <div className="page-wrapper d-flex flex-column align-items-center">
      <div className="page-wrapper-header p-3 w-100 d-none d-sm-flex align-items-center">
        <CharmaLogo type="long-white" width="144" className="mb-3" />
      </div>
      <div className="page-wrapper-body d-flex w-100 flex-grow-1">{children}</div>
    </div>
  );
}

export default PageWrapper;
